import { IAppState } from 'shared/common/state';

export function selectAllOfferChatOnboardings(state: IAppState) {
  return state.chatOnboarding.allOfferChatOnboardings;
}
